import type { ReactNode } from "react";
import type { Language } from "../model/language.ts";
import { LanguageContext } from "./languageContext.ts";

/**
 * Wraps the whole app (see App.tsx) — the `language` value itself (state +
 * localStorage persistence) lives in App.tsx, same as `theme`; this Provider
 * only distributes it via context so that any component can request its
 * text with `useT()` without having to thread it as a prop through every
 * intermediate level (unlike `theme`, which today only reaches a handful of
 * places, `language` is meant to reach nearly every component under
 * `src/ui`, as the translation keeps being extended).
 */
export function LanguageProvider({
  language,
  children,
}: {
  language: Language;
  children: ReactNode;
}) {
  return <LanguageContext.Provider value={language}>{children}</LanguageContext.Provider>;
}
